export enum ChatType
{
  Private = 1,
  Group = 2,
}
